import {validNfeKey} from './nfeIntake.js';

// A captured photo/QR/barcode is a key lookup hint, NOT a tax document.
export function extractNfeAccessKey(raw) {
  const input=String(raw??'').trim();
  if(!input || input.length>8192) throw Error('Código vazio ou muito extenso.');
  const noSeparators=input.replace(/[\s.\-]/g,'');
  const matches=/^\d{44}$/.test(noSeparators)
    ? [noSeparators]
    : (input.match(/(?:^|\D)\d{44}(?=\D|$)/g)||[]).map(v=>v.replace(/^\D/,''));
  const candidates=[...new Set(matches)];
  if(candidates.length===0) throw Error('Não encontrei a chave de 44 dígitos. Aponte para o código de barras do DANFE ou digite a chave.');
  const valid=candidates.filter(validNfeKey);
  if(valid.length!==1) throw Error(valid.length>1?'A imagem contém várias chaves. Escaneie somente uma NF-e.':'Chave de acesso com dígito verificador inválido. Tente novamente.');
  const key=valid[0];
  if(key.slice(20,22)!=='55')
    throw Error(key.slice(20,22)==='65'?'Este documento é uma NFC-e (modelo 65). Para entrada de mercadorias, utilize uma NF-e modelo 55.':'O código não pertence a uma NF-e modelo 55.');
  return key;
}

export async function readNfeKeyFromImage(file,{NativeDetector=globalThis.BarcodeDetector,createBitmap=globalThis.createImageBitmap,loadZXing}={}) {
  if(!file || !file.type?.startsWith('image/') || file.size>8*1024*1024 || file.size===0)
    throw Error('Selecione uma foto JPG, PNG ou WebP com até 8 MB.');
  const errors=[];
  if(typeof NativeDetector==='function' && typeof createBitmap==='function') {
    let bitmap;
    try {
      const formats=(await NativeDetector.getSupportedFormats()).filter(f=>['code_128','qr_code','itf'].includes(f));
      if(formats.length){
        bitmap=await createBitmap(file);
        const detector=new NativeDetector({formats});
        const findings=await detector.detect(bitmap);
        for(const result of findings){
          try {return extractNfeAccessKey(result.rawValue);}
          catch(e){errors.push(e.message)}
        }
      }
    }catch {/* Use installed ZXing fallback without uploading the photo. */}
    finally {bitmap?.close?.();}
  }
  const loader=loadZXing || (()=>import('@zxing/browser'));
  const {BrowserMultiFormatReader}=await loader();
  const url=URL.createObjectURL(file);
  try{
    const reader=new BrowserMultiFormatReader();
    const result=await reader.decodeFromImageUrl(url);
    return extractNfeAccessKey(result.getText());
  }catch(e){
    if(/NF-e|NFC-e|chave|dígito|44 dígitos/i.test(e.message||''))throw e;
    if(errors.length) throw Error(errors[0]);
    throw Error('Não consegui identificar o código na foto. Fotografe o código de barras com boa iluminação ou digite a chave.');
  }finally{URL.revokeObjectURL(url);}
}
